import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { filter, includes } from 'lodash';
import { branch } from 'baobab-react/higher-order';
import Header from '../../common/Header';
import NavBar from './NavBar';
import Video from './Video';
import SupportNav from '../SupportNav';
import videoData from './videoData.json';
import Breadcrumb from '../../common/Breadcrumb';
import BreadcrumbItem from '../../common/BreadcrumbItem';

class Videos extends Component {
	constructor(props) {
		super(props);
		this.state = {
			search: ''
		};
	}

	filterVideos() {
		const videos = videoData;
		let locationFiltered = videos;
		let searchFiltered = videos;
		if (this.props.location.state) {
			locationFiltered = filter(videos, video => {
				return includes(video.category.toLowerCase(),this.props.location.state.tag.toLowerCase());
			});
		}

		if (this.state.search) {
			searchFiltered = filter(videos, video => {
				return (
					includes(video.title.toLowerCase(),this.state.search.toLowerCase()) ||
					includes(video.tag.toLowerCase(),this.state.search.toLowerCase())
				);
			});
			return searchFiltered;
		} else {
			return locationFiltered;
		}
	}

	updateSearch(search) {
		this.setState({ search });
	}

	render() {
		const { search } = this.state;
		const { title } = this.props.location.state;
		const videos = this.filterVideos().map((video, index) => (
			<Video
				video={ video }
				key={ index }
			/>
		));
		
		return (
			<div className="video-library">
				<Helmet>
					<title>{ title ? `Videos: ${title}` : 'Video Library' } &#124; SentrySafe</title>
					<meta name="description" content="Use these videos to guide you through your safe setup, troubleshooting, and other support needs. View videos." />
				</Helmet>

				<Breadcrumb>
					<BreadcrumbItem label="Support" path="/support" />
					<BreadcrumbItem label="Videos" />
				</Breadcrumb>

				<SupportNav />

				<Header
					title="Video Library"
					description="Use these videos to guide you through your safe setup, troubleshooting, and other support needs."
				/>

				<NavBar onChange={ text => this.updateSearch(text) }/>

				<section className="section section-videos">
					<div className="section-content">
						<p className="video-count">
							{ videos.length }
							{ videos.length === 1 ? ' video' : ' videos' } returned
							{ search.length ? ` for “${search}”` : '' }
						</p>
						<ul>
							{ videos }
						</ul>
					</div>
				</section>
			</div>
		);
	}
}

export default branch({
	product: ['product']
}, Videos);


// WEBPACK FOOTER //
// ./src/pages/support/videos/Index.js